import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface DevModeContextType {
  isDevMode: boolean;
  toggleDevMode: () => void;
}

const DevModeContext = createContext<DevModeContextType | undefined>(undefined);

const DEV_MODE_KEY = 'dev-mode-fresh-user';

export function DevModeProvider({ children }: { children: ReactNode }) {
  const [isDevMode, setIsDevMode] = useState(() => {
    return sessionStorage.getItem(DEV_MODE_KEY) === 'true';
  });

  useEffect(() => {
    sessionStorage.setItem(DEV_MODE_KEY, isDevMode.toString());
  }, [isDevMode]);

  const toggleDevMode = () => {
    setIsDevMode(prev => !prev);
  };

  return (
    <DevModeContext.Provider value={{ isDevMode, toggleDevMode }}>
      {children}
    </DevModeContext.Provider>
  );
}

export function useDevMode() {
  const context = useContext(DevModeContext);
  if (context === undefined) {
    throw new Error('useDevMode must be used within a DevModeProvider');
  }
  return context;
}
